import React, { ReactNode } from "react";
import { Card, Row, Col } from "react-bootstrap";
import ExtensionIcon from "@mui/icons-material/Extension";
import HotelIcon from "@mui/icons-material/Hotel";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import BathtubIcon from "@mui/icons-material/Bathtub";
import ServicioCard from "./ServicioCard";
import styled from "styled-components";
import { useUsuarioActual } from "../../../services/authServicios";
import { puedeAccederRuta } from "../../../services/rolAutorizacion";
import {
  RUTA_RESERVAS_GUARDERIA,
  RUTA_RESERVAS_HOTEL,
  RUTA_RESERVAS_SPA,
  RUTA_RESERVAS_ENTRENAMIENTO,
} from "../../../services/rutas";

function CardSection() {
  const { data: usuario } = useUsuarioActual();

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-12 col-lg-8 col-xxl-6">
        <Card>
          <StyledCardHeader className="mt-2">
            <TitleContainer>
              <CardTitle fontSize={24}>Reserva por tipo de servicio</CardTitle>
            </TitleContainer>
          </StyledCardHeader>
          <Card.Body>
            <Row className="justify-content-center mb-2 p-3">
              {puedeAccederRuta(usuario, RUTA_RESERVAS_GUARDERIA) && (
                <CardCol>
                  <ServicioCard
                    Icono={ExtensionIcon}
                    ruta={RUTA_RESERVAS_GUARDERIA}
                    titulo="Guardería"
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_RESERVAS_HOTEL) && (
                <CardCol>
                  <ServicioCard
                    Icono={HotelIcon}
                    ruta={RUTA_RESERVAS_HOTEL}
                    titulo="Hotel"
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_RESERVAS_SPA) && (
                <CardCol>
                  <ServicioCard
                    Icono={BathtubIcon}
                    ruta={RUTA_RESERVAS_SPA}
                    titulo="Spa"
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_RESERVAS_ENTRENAMIENTO) && (
                <CardCol>
                  <ServicioCard
                    Icono={MilitaryTechIcon}
                    ruta={RUTA_RESERVAS_ENTRENAMIENTO}
                    titulo="Entrenamiento"
                  />
                </CardCol>
              )}
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

const CardCol = ({ children }: { children: ReactNode }) => {
  return (
    <Col xs={12} md={6} sm={6} className="mb-2">
      {children}
    </Col>
  );
};

const CardTitle = styled("h4")<{ fontSize?: number }>`
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "20px")};
  font-weight: 500;
  color: #454545;
  letter-spacing: 0.05em;
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background-color: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0px;
`;

const TitleContainer = styled("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default CardSection;
